(function () {
  const script = document.currentScript;
  const iconUrl = script && script.dataset.toytopiaChatIcon;

  if (!iconUrl) return;

  const homepage = Boolean(document.querySelector('.tt-v4'));
  const styleId = 'toytopia-chat-branding';
  const brandedAttribute = 'data-toytopia-branded';
  const observedRoots = new WeakSet();

  function brandRoot(root) {
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .activator {
          min-height: 52px !important;
          padding: 6px 16px 6px 8px !important;
          gap: 9px !important;
          border-radius: 999px !important;
          font-family: Parkinsans, sans-serif !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          letter-spacing: -0.01em !important;
          color: #2a2a2a !important;
          background: rgba(255, 255, 255, 0.96) !important;
          box-shadow:
            0 10px 24px rgba(42, 42, 42, 0.14),
            0 0 0 1px rgba(22, 181, 140, 0.16) !important;
          transition: transform 180ms cubic-bezier(0.22, 1, 0.36, 1),
            box-shadow 180ms cubic-bezier(0.22, 1, 0.36, 1);
        }

        .activator-nudge {
          left: auto !important;
          right: max(16px, env(safe-area-inset-right)) !important;
          width: max-content !important;
          margin: 0 !important;
        }

        .activator:hover {
          transform: translateY(-2px);
          box-shadow:
            0 14px 28px rgba(42, 42, 42, 0.18),
            0 0 0 2px rgba(22, 181, 140, 0.22);
        }

        .activator:focus-visible {
          outline: 3px solid #f59e0b;
          outline-offset: 3px;
        }

        :host-context(.cart-drawer-open) .activator-nudge,
        :host-context(.predictive-search-open) .activator-nudge {
          opacity: 0 !important;
          pointer-events: none !important;
          transform: translateY(12px) !important;
        }

        .activator__icon {
          display: grid !important;
          width: 38px !important;
          height: 38px !important;
          flex: 0 0 38px !important;
          place-items: center !important;
        }

        .activator__icon img {
          display: block !important;
          width: 38px !important;
          height: 38px !important;
        }

        @media (max-width: 480px) {
          .activator {
            min-height: 48px !important;
            padding: 5px 14px 5px 7px !important;
            gap: 8px !important;
          }

          .activator__icon,
          .activator__icon img {
            width: 36px !important;
            height: 36px !important;
            flex-basis: 36px !important;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .activator {
            transition: none;
          }
        }
      `;
      if (homepage) style.textContent += `
        .activator { display: inline-flex !important; align-items: center !important; width: auto !important; min-height: 56px !important; padding: 7px 20px 7px 8px !important; gap: 10px !important; background: #fff !important; color: #073d32 !important; border: 1px solid #b9ded2 !important; box-shadow: 0 4px 18px #073d3220 !important; }
        .activator .activator__label { position: static !important; margin: 0 !important; color: #073d32 !important; font-size: 15px !important; font-weight: 700 !important; opacity: 1 !important; }
        .activator__icon { position: static !important; margin: 0 !important; display: grid !important; width: 40px !important; height: 40px !important; flex: 0 0 40px !important; }
        .activator__icon img { width: 40px !important; height: 40px !important; border-radius: 50%; padding: 0 !important; }
      `;
      root.appendChild(style);
    }

    const icon = root.querySelector('.activator__icon');
    if (icon && !icon.hasAttribute(brandedAttribute)) {
      const image = document.createElement('img');
      image.src = iconUrl;
      image.alt = '';
      image.width = 38;
      image.height = 38;
      image.setAttribute('aria-hidden', 'true');
      icon.replaceChildren(image);
      icon.setAttribute(brandedAttribute, 'true');
    }

    if (homepage) {
      const label = root.querySelector('.activator__label');
      const title = document.documentElement.lang.startsWith('ar') ? 'تحدث معنا' : 'Chat with us';
      if (label && label.textContent !== title) label.textContent = title;
      const button = root.querySelector('.activator');
      if (button) button.setAttribute('aria-label', title);
    }

    root.querySelectorAll('shopify-agent-runtime').forEach(function (runtime) {
      if (runtime.shadowRoot) observeRoot(runtime.shadowRoot);
    });
  }

  function observeRoot(root) {
    brandRoot(root);
    if (observedRoots.has(root)) return;

    const observer = new MutationObserver(function () {
      brandRoot(root);
    });
    observer.observe(root, { childList: true, subtree: true });
    observedRoots.add(root);
  }

  function initialize() {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;

    const attach = function () {
      if (!chat.shadowRoot) return;
      observeRoot(chat.shadowRoot);
    };

    if (chat.shadowRoot) {
      attach();
      return;
    }

    requestAnimationFrame(attach);
  }

  customElements.whenDefined('shopify-chat').then(initialize);
})();

